/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FaceASadIcon16Light } from './FaceASadIcon16Light';
import { FaceASadIcon16Regular } from './FaceASadIcon16Regular';
import { FaceASadIcon16Solid } from './FaceASadIcon16Solid';
import { FaceASadIcon20Light } from './FaceASadIcon20Light';
import { FaceASadIcon20Regular } from './FaceASadIcon20Regular';
import { FaceASadIcon20Solid } from './FaceASadIcon20Solid';
import { FaceASadIcon24Regular } from './FaceASadIcon24Regular';
import { FaceASadIcon24Solid } from './FaceASadIcon24Solid';
import { FaceASadIcon32Regular } from './FaceASadIcon32Regular';
import { FaceASadIcon64Regular } from './FaceASadIcon64Regular';
var sizes = {
    16: {
        light: FaceASadIcon16Light,
        regular: FaceASadIcon16Regular,
        solid: FaceASadIcon16Solid,
    },
    20: {
        light: FaceASadIcon20Light,
        regular: FaceASadIcon20Regular,
        solid: FaceASadIcon20Solid,
    },
    24: {
        regular: FaceASadIcon24Regular,
        solid: FaceASadIcon24Solid,
    },
    32: {
        regular: FaceASadIcon32Regular,
    },
    64: {
        regular: FaceASadIcon64Regular,
    },
};
export var FaceASadIcon = forwardRef('FaceASadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
